import _sortBy from 'lodash/sortBy';
import _camelCase from 'lodash/camelCase';
import { useTranslation } from '@packlink/translation-provider';
import { useMemo } from 'react';
import { DETAILS_FILTERS_TO_SHOW } from '../constants/filters.js';
import { HOURS_LIMIT } from '../constants/hoursLimit.js';
import { ServiceTypes } from '../types/types.js';

/**
 * @description Return initial Filter Structure
 */

function createFilter(key, name, icon) {
  return {
    key,
    name,
    icon
  };
}
function isFilterIncludedInArray(myArray, dataToCheck, checkBy) {
  return dataToCheck ? myArray.some(filter => filter[checkBy] === dataToCheck) : false;
}
function useFiltersStructure(services, debugMode) {
  const {
    t,
    i18n
  } = useTranslation();
  const filterStructure = useMemo(() => {
    const carriers = [];
    const collectionTypes = [];
    const deliveryTypes = [];
    const serviceDetails = [];
    const transitHoursFilter = [];
    const tagTypes = [];
    services === null || services === void 0 ? void 0 : services.forEach(service => {
      const {
        carrierName,
        dropOff,
        serviceInfo,
        transitHours,
        tags
      } = service;
      //Carriers filters
      if (carrierName && !isFilterIncludedInArray(carriers, carrierName, 'name')) {
        carriers.push(createFilter(_camelCase(carrierName), carrierName));
      }
      //Service types
      if (dropOff) {
        const {
          origin,
          destination
        } = dropOff;
        //Collection types filters
        const collectionName = origin ? t('service-list.filters.drop-off') : t('service-list.filters.collection');
        if (!isFilterIncludedInArray(collectionTypes, collectionName, 'name')) {
          const iconName = origin ? 'marker' : 'house';
          const collectionKey = origin ? ServiceTypes.DROPOFF : ServiceTypes.COLLECTION;
          collectionTypes.push(createFilter(_camelCase(collectionKey), collectionName, iconName));
        }
        //Delivery types filters
        const deliveryName = destination ? t('service-list.filters.pick-up') : t('service-list.filters.delivery');
        if (!isFilterIncludedInArray(deliveryTypes, deliveryName, 'name')) {
          const iconName = destination ? 'marker' : 'house';
          const deliveryKey = destination ? ServiceTypes.PICKUP : ServiceTypes.DELIVERY;
          deliveryTypes.push(createFilter(_camelCase(deliveryKey), deliveryName, iconName));
        }
      }
      //Service details filters
      serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.forEach(info => {
        if (info.text && !isFilterIncludedInArray(serviceDetails, _camelCase(info.text), 'key') && (debugMode || i18n.exists(info.text)) && DETAILS_FILTERS_TO_SHOW.some(detailsIcon => info.icon === detailsIcon)) {
          serviceDetails.push(createFilter(_camelCase(info.text), t(info.text), info.icon));
        }
      });
      //Transit time filters
      if (transitHours && !isFilterIncludedInArray(transitHoursFilter, transitHours.toString(), 'key')) {
        const duration = transitHours;
        const transitUnit = t(`service-list.side-panel.transit-time-option-label-${duration > HOURS_LIMIT ? 'days' : 'hours'}`);
        transitHoursFilter.push(createFilter(transitHours.toString(), `${duration > HOURS_LIMIT ? Math.round(duration / 24).toString() : duration.toString()} ${transitUnit}`));
      }
      //Tag types filters
      tags === null || tags === void 0 ? void 0 : tags.forEach(tag => {
        if (tag.id && !isFilterIncludedInArray(tagTypes, tag.id, 'key')) {
          const normalizedTagId = tag.id.replace(/_/g, '-').toLowerCase();
          const tagTypeName = t(`service-list.filters.${normalizedTagId}`);
          tagTypes.push(createFilter(tag.id, tagTypeName));
        }
      });
    });
    const sortedTransitHours = _sortBy(transitHoursFilter, ['key']);
    const sortedCarriers = _sortBy(carriers, ['name']);
    return {
      carriers: sortedCarriers,
      collectionTypes,
      deliveryTypes,
      serviceDetails,
      transitHours: sortedTransitHours,
      tagTypes
    };
  }, [services, t, i18n, debugMode]);
  return filterStructure;
}

export { useFiltersStructure };
//# sourceMappingURL=useFiltersStructure.js.map
